import { render, staticRenderFns } from "./ActionTextRenderer.vue?vue&type=template&id=6d1f8ae8&"
import script from "./ActionTextRenderer.vue?vue&type=script&lang=js&"
export * from "./ActionTextRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports